//
// forms/gdpr.js - hide/precheck GDPR fields depending on local legal regime
//

import {curry} from '../helpers/functional';
import {remove_field} from './helpers';
import {set_value_div} from './value-extractor';


export default function gdpr(form_div) {
  const gdpr_items = form_div.querySelectorAll(
    '.c-form-set[data-name*="gdpr"], .c-form-set[data-name*="GDPR"], .c-form-set[data-name*="gDPR"]'
  );
  if (gdpr_items.length === 0) {
    return;
  }

  window.global_geo_ip_promise
    .then(curry(run_gdpr, gdpr_items))
    .catch(() => { });  // if the API fails, just don't hide anything
}


// run_gdpr()
// -------------------------------------

function run_gdpr(gdpr_items, country_code) {
  if (global_is_gdpr_country(country_code)) {
    if (global_is_gdpr_precheck_country(country_code)) {
      gdpr_items.forEach(item => set_value_div(item, 'True'));
    }
  }
  else {
    gdpr_items.forEach(remove_field);
  }
}

